import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { AddUserDto } from 'src/app/model/qModel.model';
import { ReCaptcha2Component } from 'ngx-captcha';
import { Location } from '@angular/common';
declare let $: any;
@Component({
  selector: 'app-add-device',
  templateUrl: './add-device.component.html',
})
export class AddDeviceComponent implements OnInit {
  @ViewChild('ngOtpInput') ngOtpInputRef: any;
  @ViewChild("testInput") testInput: any;
  @ViewChild('productKey') productKey: any;
  @ViewChild('captchaElem') captchaElem: ReCaptcha2Component;

  productKeyOrDeviceIdforCancel: any;
  getdeviceTypeForCancel: any;
  alreadyExist: boolean = false;
  otpChar: string = '';
  isLoading: boolean = false;
  resendotp: boolean = false;
  isSubmitted = false;
  otpValue: string = "";
  isdeviceProducyKeyVerified: boolean = false;
  isProducyKeyVerified: boolean = false;
  loggedInUser: any;
  isAddAnotherDevice: boolean = false;
  isOTP: boolean = false;
  timer: any;
  counts: number = 0;
  durationMinutes: any;
  timeOver: any;
  deviceType: any;
  slaveKey: any;
  getProductKeyType: string = '';
  isProducyKeyVerifieds: boolean = false;
  verifyProductKeyErrorMessage: any;
  deviceNameErrorMessage: any;
  keyupType: any;
  addUserDto: AddUserDto = new AddUserDto()
  addDeviceForm: FormGroup = new FormGroup({
    deviceName: new FormControl(''),
    productKey: new FormControl(''),
    captchaToken: new FormControl(''),
  });

  otpErrorMessage: any;
  showCaptcha: boolean = false;
  packInfo: any;
  disableAdd: boolean = true;
  disablebtn: boolean = false;
  pendingOtpData: any = []

  constructor(private _service: ApiService, private _toastr: ToastrService, private _formBuilder: FormBuilder, private _router: Router, private location: Location) { }


  ngAfterViewInit() {
    this.testInput.nativeElement.focus();
    if (this.showCaptcha) {
      this.addDeviceForm.controls['captchaToken'].addValidators(Validators.required);
    }
  }
  ngOnInit(): void {
    if (this.showCaptcha) {
      this.addDeviceForm.controls['captchaToken'].addValidators(Validators.required);
    }
    this.addDeviceForm = this._formBuilder.group(
      {
        deviceName: ['', [Validators.required]],
        productKey: ['', [Validators.required]],
        captchaToken: ['']
      },
    );
    let currentUser = localStorage.getItem('currentUser');
    if (currentUser) {
      this.loggedInUser = JSON.parse(currentUser);
    }
    this.pendingOtp();
  }

  goBack() {
    this.location.back()
  }

  onDeviceClick(event: any, data: any) {
    event.target.checked = true;
    this.disableAdd = false;
    this.disablebtn = false;
    this.isProducyKeyVerified = true;
    this.deviceType = data.deviceType;
    this.slaveKey = data.slaveKey;
  }

  //  Adding the Device here
  enableAdd: boolean = true;
  onAddDevice() {
    this.durationMinutes = '';
    this.enableAdd = false
    try {
      this.isLoading = true;
      this.isSubmitted = true;
      if (this.packInfo) {
        this.addUserDto.masterKey = this.addDeviceForm.controls['productKey'].value
        this.addUserDto.deviceName = this.addDeviceForm.controls['deviceName'].value
        this.addUserDto.captchaToken = this.addDeviceForm.controls['captchaToken'].value
        this.addUserDto.deviceType = this.deviceType,
          this.addUserDto.productKeyOrDeviceId = this.slaveKey
      } else {
        this.addUserDto.productKeyOrDeviceId = this.addDeviceForm.controls['productKey'].value
        this.addUserDto.deviceName = this.addDeviceForm.controls['deviceName'].value
        this.addUserDto.captchaToken = this.addDeviceForm.controls['captchaToken'].value
      }
      this._service.postService(this._service.API_URL.addDeviceSendOtp, this.addUserDto).subscribe((response: any) => {
        if (response.status.code === 200) {
          this.enableAdd = false;
          this.otpChar = response.data.otpChar;
          this.isLoading = false;
          this.getProductKeyType = response.data;
          this.productKeyOrDeviceIdforCancel = response.data.productKeyOrDeviceId;
          this.getdeviceTypeForCancel = response.data.deviceType;
          this.isOTP = true;
          this.timeOver = true;
          clearInterval(this.timer);
          this.startTimerForFiveMinute(3);

          this.otpErrorMessage = null;
          $("#OtpPopup").modal("show");
        } else {
          this.isOTP = false;
          this.timeOver = false;
          this.isLoading = false;
          this.alreadyExist = true;
          if ("DEVICE_NAME_REG" == response.status.msgCode) {
            this.deviceNameErrorMessage = response.status.message;
          } else {
            this.verifyProductKeyErrorMessage = response.status.message;
          }

          this.isLoading = false;
          this.enableAdd = true;
        }
      })
    } catch (error) {
      this.isLoading = false;
      this.enableAdd = true;
    }
  }

  addAnotherDevice() {
    this.isAddAnotherDevice = true;
  }

  onOtpChange(event: any) {
    this.otpErrorMessage = null;
    this.otpValue = event;
  }


  onDeviceNameInput() {
    this.enableAdd = true;
    this.deviceNameErrorMessage = null;
  }
  checkCallOnce: boolean = false;
  verifyProductKeyFromAddDevice(event: any) {
    let data = {
      productKey: this.addDeviceForm.controls['productKey'].value.split('-').join(''),
      isSignUp: false
    }
    let selectionStart = event.target.selectionStart, key = event.key;
    if (key != 'Backspace' && key != 'Control' && key != 'Delete' && key != 'Enter' && key != 'Space' && !this.checkCallOnce && key != 'ArrowRight' && key != 'ArrowLeft' && key != 'ArrowUp' && key != 'ArrowDown') {
      switch (selectionStart) {
        case 6:
          event.target.setSelectionRange(7, 7);
          break;
        case 12:
          event.target.setSelectionRange(13, 13);
          break;
        case 18:
          event.target.setSelectionRange(19, 19);
          break;
        case 21:
          event.target.setSelectionRange(21, 21);
          break;
        case 22:
          event.target.setSelectionRange(22, 22);
          break;
      }
      try {
        if (data.productKey?.length == 20) {
          if (selectionStart == 20) {
            event.target.setSelectionRange(23, 23);
          }

          this.checkCallOnce = true;
          this.isLoading = true;
          this._service.postService(this._service.API_URL.verifyProductKey, data).subscribe((response: any) => {
            if (response && response.status.code === 200) {
              this.checkCallOnce = true;
              this.isLoading = false;
              this.disableAdd = false
              this.verifyProductKeyErrorMessage = null;
              this.isProducyKeyVerified = true;
              this.isProducyKeyVerifieds = false;
              if (response.data.packInfo) {
                setTimeout(() => {
                  this.disablebtn = true;
                }, 0);
              }
              this.packInfo = response.data.packInfo;
              this.otpErrorMessage = null;
              if (this.counts >= 3) {
                this.showCaptcha = true;
                this.addDeviceForm.controls['captchaToken'].addValidators(Validators.required);
              }
              else {
                this.showCaptcha = false
              }
            } else if (response && response.status.code === 400) {
              this.verifyProductKeyErrorMessage = response.status.message
              this.isProducyKeyVerifieds = true;
              this.isProducyKeyVerified = false;
              if (this.addDeviceForm.controls['captchaToken'].value) {
                this.captchaElem.reloadCaptcha();
                this.addDeviceForm.controls['captchaToken'].setValue(null)
                this.addDeviceForm.controls['captchaToken'].addValidators(Validators.required);
              }
              this.counts++;
              if (this.counts >= 3) {
                this.showCaptcha = true;
                this.addDeviceForm.controls['captchaToken'].addValidators(Validators.required);
              }
              else {
                this.verifyProductKeyErrorMessage = response.status.message
                this.showCaptcha = false;
              }
              this.isLoading = false;
            } else if (response.status.msgCode === 'QH_INVALID_PRODUCT_KEY') {
              this.isProducyKeyVerifieds = true;
              this.verifyProductKeyErrorMessage = response.status.message
              this.isLoading = false;
            }
          })
        } else {
          this.checkCallOnce = false;
          this.isLoading = false;
        }
      }
      catch (e) { this.isLoading = false; this.checkCallOnce = false; }
    } else if (event.key == 'Backspace' || event.key == 'Delete') {
      if (data.productKey?.length != 20 && data.productKey?.length != 0) {
        this.verifyProductKeyErrorMessage = null
        this.checkCallOnce = false;
        this.isProducyKeyVerified = false;
        this.isProducyKeyVerifieds = true;
      } else if (data.productKey?.length == 0) {
        this.verifyProductKeyErrorMessage = null
        this.isProducyKeyVerified = false;
        this.isProducyKeyVerifieds = false;
        this.checkCallOnce = false;
      } else {
        return;
      }
    }
  }

  //  TO get the OTP and Add the device

  submitOTP(): void {
    this.isLoading = true;
    try {
      if (this.otpValue?.length === 4) {
        if (this.packInfo) {
          this.addUserDto.deviceName = this.addDeviceForm.controls['deviceName'].value
          this.addUserDto.productKeyOrDeviceId = this.slaveKey
          this.addUserDto.otp = this.otpValue
          this.addUserDto.deviceType = this.deviceType
          this.addUserDto.otpChar = this.otpChar
        } else {
          this.addUserDto.productKeyOrDeviceId = this.addDeviceForm.controls['productKey'].value
          this.addUserDto.deviceName = this.addDeviceForm.controls['deviceName'].value
          this.addUserDto.otp = this.otpValue
          this.addUserDto.otpChar = this.otpChar
        }
        this._service.postService(this._service.API_URL.addDevice, this.addUserDto).subscribe((response) => {
          if (response && response.status.code === 200) {
            this.isLoading = false;
            this._toastr.success('', response.status.message);
            this._router.navigate(['home/manage-device']);
            $("#OtpPopup").modal("hide");
            this.pendingOtpData = [];
            this.isdeviceProducyKeyVerified = true;
            if (response.status.code === 400) {
              this.otpErrorMessage = response.status.message;
            }
          }
          if (response.status.code === 400) {
            this.otpErrorMessage = response.status.message;
          }
        })
      }
    }
    catch (e) {

    }

  }

  //  Starting the timer here
  startTimerForFiveMinute(minute: number) {
    if (this.timer) {
      clearInterval(this.timer);
    }
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 60;
    const prefix = minute < 10 ? "0" : "";
    this.timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;
      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.durationMinutes = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
      if (seconds == 0) {
        this.timeOver = false;
        clearInterval(this.timer);
      }
    }, 1000);
  }


  //  Resend OTP Logic is written here
  resendOtp() {
    try {
      clearInterval(this.timer);
      this.ngOtpInputRef.setValue(null);
      this.otpErrorMessage = null;
      if (this.packInfo) {
        this.addUserDto.masterKey = this.addDeviceForm.controls['productKey'].value
        this.addUserDto.deviceName = this.addDeviceForm.controls['deviceName'].value
        this.addUserDto.deviceType = this.deviceType
        this.addUserDto.productKeyOrDeviceId = this.slaveKey
        this.addUserDto.isResendOTP = true
        this.otpErrorMessage = null
      } else {
        this.addUserDto.productKeyOrDeviceId = this.addDeviceForm.controls['productKey'].value
        this.addUserDto.deviceName = this.addDeviceForm.controls['deviceName'].value
        this.addUserDto.isResendOTP = true
      }
      this.isOTP = true;
      this.timeOver = true;
      this.startTimerForFiveMinute(3);
      this._service.postService(this._service.API_URL.addDeviceSendOtp, this.addUserDto).subscribe((response: any) => {
        if (response && response.status.code === 200) {
          this.otpChar = response.data.otpChar;
          this.getProductKeyType = response.data;
        }
      })
    }
    catch (e) {
    }
  }
  routeback() {
    history.back();
  }

  cancelOTPManageDevice() {
    try {

      this.addUserDto.productKeyOrDeviceId = this.productKeyOrDeviceIdforCancel
      this.addUserDto.productKeyType = this.getdeviceTypeForCancel
      this.ngOtpInputRef.setValue(null);
      this._service.postService(this._service.API_URL.cancelOTPManageDevice, this.addUserDto).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.otpErrorMessage = null;
          $("#OtpPopup").modal("hide");
          this.pendingOtp();
          this.isLoading = false;
        } else {
          $("#OtpPopup").modal("hide");
          clearInterval(this.timer);
          this.pendingOtp();
          this.isLoading = false;
        }
      })
    } catch (error) {
      this.isLoading = false;
    }



  }

  isPaste: boolean = false;
  pasteEvent(event: any) {
    this.isPaste = true;
  }


  // Allow numbers, alpahbets, space, underscore
  keyPressAlphaNumericWithCharacters(event: any, name: any) {
    if (event.target.selectionStart === 0) {
      let k;
      k = event.charCode;  //         k = event.keyCode;  (Both can be used)
      return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
    } else if (name == 'key') {
      if (event.code === "Space") {
        event.preventDefault();
        return false;
      }
      let k;
      k = event.charCode;  //         k = event.keyCode;  (Both can be used)
      return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57))
    } else {
      let inp = String.fromCharCode(event.keyCode);
      // Allow numbers, alpahbets, space, underscore
      if (/[a-zA-Z0-9-_ ]/.test(inp)) {
        return true;
      } else {
        event.preventDefault();
        return false;
      }
    }

  }


  // for no allowing to enter space
  removeSpace(event: any, name: any) {
    if (name == 'key') {
      if (event.code === "Space") {
        event.preventDefault();
        return false;
      }
    } else {
      if (event.target.selectionStart === 0 && event.code === "Space") {
        event.preventDefault();
        return false;
      }
    }
  }
  // for adding first letter as Alphabet only
  onlyAlphabets(event: any) {
    if (event.target.selectionStart === 0) {
      if ((/\d/g).test(event.key)) event.preventDefault();
    }
  }

  pendingOtp() {
    try {
      this._service.getService(this._service.API_URL.pendingOtp).subscribe((response) => {
        if (response && response.status.code == 200) {
          this.pendingOtpData = response.data;
        }
      })
    } catch (error) {
      console.error(error)
    }
  }
  showOtpPopup(val: any) {
    $("#OtpPopup").modal("show");
    this.otpChar = val.otpChar;
    this.productKeyOrDeviceIdforCancel = val.id;
    this.getdeviceTypeForCancel = val.deviceType;
  }
}
